import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import { Nav } from 'react-bootstrap';
import SidebarNavItem from './SidebarNavItem';
const SidebarNavDropdown = ({ isCollapsed, pathname, submenus, title, icon: Icon }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    useEffect(() => {
        if (isCollapsed) {
            setIsExpanded(false);
        }
    }, [isCollapsed]);
    const isActive = isCollapsed && submenus.some((submenu) => submenu.href === pathname);
    const handleClick = useCallback((event) => {
        if (!isCollapsed) {
            event.stopPropagation();
            setIsExpanded((prevState) => !prevState);
        }
    }, [isCollapsed]);
    return (_jsxs(Nav.Item, { children: [_jsxs(Nav.Link, Object.assign({ onClick: handleClick, className: `${isActive ? 'active' : ''}` }, { children: [!!Icon && _jsx(Icon, {}), !isCollapsed && _jsx("span", { children: title })] })), isExpanded &&
                submenus.map((submenu) => (_createElement(SidebarNavItem, Object.assign({}, submenu, { key: submenu.title, isSubmenu: true }))))] }));
};
export default SidebarNavDropdown;
